import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../util/createLifeomicActionTypes';

const actionTypes = createActionTypes(['ADD_DOWNLOAD_URL_FOR_INVOICE']);

const asyncActions = createAsyncActionTypes([
  'FETCH_INVOICES',
  'FETCH_INVOICES_START',
  'FETCH_INVOICES_SUCCESS',
  'FETCH_INVOICES_ERROR',
  'FETCH_INVOICE_DOWNLOAD_URL',
  'FETCH_INVOICE_DOWNLOAD_URL_START',
  'FETCH_INVOICE_DOWNLOAD_URL_SUCCESS',
  'FETCH_INVOICE_DOWNLOAD_URL_ERROR',
]);

export default {
  ...actionTypes,
  ...asyncActions,
};
